import React from 'react';
import OperationsApp from './commerce/OperationsApp';
export default function AdminApp(){return <OperationsApp mode="admin"/>;}
